/** ----------------------------------------
    Video
 ---------------------------------------- */

export let revealVideo = {
    opacity: 1,
    duration: 1000,
    easing: 'easeOutQuad'
};

/** ----------------------------------------
    Controller
 ---------------------------------------- */

export let revealController = {
    translateY: (el, i) => {
        return [(i * 10), 0]
    },
    opacity: 1,
    easing: 'easeOutExpo',
    delay: (el, i) => {
        return 175 / (i + 1)
    },
    duration: 500
};

/** ----------------------------------------
    Title
 ---------------------------------------- */

export let revealTitle = {
    translateY: (el, i) => {
        return [(i + 1) * 10, 0]
    },
    opacity: [0, 1],
    easing: 'easeOutExpo',
    delay: (el, i) => {
        return 200 / ((i + 1) * 20)
    },
    duration: 675
};

export let hideTitle = {
    opacity: [1, 0],
    easing: 'easeOutCirc',
    delay: (el, i) => {
        return 200 / (i + 1)
    },
    duration: 400
};